export default __webpack_public_path__ + "static/media/Ring of Impossible Secrets.716d6434.jpg";